import { SnackbarSeverityType } from '../../../enums';

interface Bus {
  _id?: string;
  id?: string;
  name: string;
  licensePlateNo: string;
  school: string;
  deviceId?: string | null;
  isDeleted?: boolean;
  qrCode?: string;
}

interface UpsertBusRequest {
  id?: string;
  _id?: string;
  name?: string;
  licensePlateNo?: string;
  school?: string;
  deviceId?: string | null;
  isDeleted?: boolean;
}

interface BusFormValues {
  name: string;
  licensePlateNo: string;
}

interface GenerateQrDialogProps {
  open: boolean;
  bus: Bus | null;
  onClose: () => void;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
}

interface BusDialogProps {
  open: boolean;
  values: BusFormValues;
  errors: Partial<Record<keyof BusFormValues, string>>;
  loading: boolean;
  onClose: () => void;
  onChange: (field: keyof BusFormValues, value: string) => void;
  onSubmit: () => void;
  title?: string;
  submitLabel?: string;
  busId?: string;
}

interface GetBusColumnsArgs {
  onUnlink: (bus: Bus) => void;
  onEdit: (bus: Bus) => void;
  onDelete: (bus: Bus) => void;
  onGenerateQr: (bus: Bus) => void;
}
interface DeleteOrUnlinkBusDialogProps {
  open: boolean;
  action: BusAction | null;
  bus: Bus | null;
  loading?: boolean;
  onCancel: () => void;
  onCompleted: () => void;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
}

enum BusAction {
  delete = 'delete',
  unlink = 'unlink'
}

interface BusTableProps extends GetBusColumnsArgs {
  rows: Bus[];
  loading: boolean;
}

interface UseBusesArgs {
  schoolId?: string;
  onError?: (error: unknown) => void;
}

interface UseBusesResult {
  buses: Bus[];
  loading: boolean;
  refresh: () => Promise<void>;
  setBuses: React.Dispatch<React.SetStateAction<Bus[]>>;
}

interface EditBusDialogProps {
  open: boolean;
  bus: Bus | null;
  onClose: () => void;
  onSuccess: () => void;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
}

interface EnrolBusDialogProps {
  open: boolean;
  schoolId?: string;
  onClose: () => void;
  onSuccess: () => void;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
}

export {
  GenerateQrDialogProps,
  BusDialogProps,
  Bus,
  UpsertBusRequest,
  BusFormValues,
  GetBusColumnsArgs,
  DeleteOrUnlinkBusDialogProps,
  BusTableProps,
  BusAction,
  UseBusesArgs,
  UseBusesResult,
  EditBusDialogProps,
  EnrolBusDialogProps
};
